import { circleFromDiameter } from '../shared/circle-geometry.js';
export { getCircleRadiusKm } from './map-math.js';
import { getCircleRadiusKm } from './map-math.js';
import type { EditorRuntimeReadyState } from './editor-state.js';
import type { ExactRadiusActions } from './store/panel-action-contracts.js';
import { cloneFrame, cloneStroke } from './map-engine.js';
import { exactRadiusPreviewPoint } from './exact-radius-preview.js';
import { screenPointToLatLng } from './map-math.js';
import type { Stroke } from '../types/app.js';

export function resizedCirclePoints(stroke: Stroke, radiusKm: number) {
  const { center, radiusKm: currentRadius } = circleFromDiameter(stroke.points);
  const centerLat = center.lat, centerLng = center.lng;
  const dLat = stroke.points[0].lat - centerLat;
  const dLng = stroke.points[0].lng - centerLng;
  const scale = currentRadius < 1e-10 ? 1 : radiusKm / currentRadius;
  return [
    { lat: centerLat + dLat * scale, lng: centerLng + dLng * scale },
    { lat: centerLat - dLat * scale, lng: centerLng - dLng * scale },
  ];
}

interface ExactRadiusDeps {
  selectTool(tool: string): void;
  getSelectedCircleStroke: ExactRadiusActions['getSelectedCircleStroke'];
  clearSelection(): void;
  redraw(): void;
  updateModeHint(): void;
  scheduleUrlSync(): void;
  placeCircle(center: { lat: number; lng: number }): void;
  track: ExactRadiusActions['track'];
}

export function createExactRadiusActions(state: EditorRuntimeReadyState, deps: ExactRadiusDeps): ExactRadiusActions {
  return {
    onToolSelectCallback: deps.selectTool,
    getSelectedCircleStroke: deps.getSelectedCircleStroke,
    getCircleRadiusKm,
    applyExactRadiusKm: (stroke, radiusKm) => {
      const before = cloneStroke(stroke);
      const after = { ...cloneStroke(stroke), points: resizedCirclePoints(stroke, radiusKm) };
      state.drawingDocument.commit({
        type: 'update_strokes', before: [before], after: [after],
        frameBefore: cloneFrame(state.selectionState.frame), frameAfter: null,
      });
      deps.scheduleUrlSync();
      deps.redraw();
    },
    updateExactRadiusPlacement: (radiusKm, unit, mapBottom) => {
      state.pendingExactRadiusCircle = { radiusKm, unit, mapBottom };
      deps.clearSelection();
      deps.updateModeHint();
      deps.redraw();
    },
    cancelExactRadiusPlacement: () => {
      state.pendingExactRadiusCircle = null;
      state.cursorPreviewPoint = null;
      deps.updateModeHint();
      deps.redraw();
    },
    placeExactRadiusAtPreview: () => {
      const point = exactRadiusPreviewPoint(state);
      const center = point && screenPointToLatLng(state, point);
      if (center) deps.placeCircle(center);
    },
    track: deps.track,
  };
}
